import React from 'react'
// components
import InjuryMasterMapping from '../InjuryMasterMapping'

interface Props {
  field: string
}

const CreateCase: React.FC<Props> = ({ field }) => (
  <InjuryMasterMapping
    isCreate
    field={field}
    description="Creates the Injury Master incident once per record, and shows it on the form's Injury Master Links fields. Person and Cost centre are required, they must already be synced to Injury Master."
  />
)

export default CreateCase
